import { Field, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import KibabMenu from "../../../../../assets/icons/kibab-menu";
import { useDispatch } from "react-redux";
import {
  addTaxTypeAction,
  deleteTaxTypeAction,
  taxTypeListAction,
  updateTaxTypeAction,
} from "../../../../../redux/actions/settings-action";
import DeleteIcon from "../../../../../assets/icons/delete-icon";
import successToast from "../../../../helper-components/success-toast";
import errorToast from "../../../../helper-components/error-toast";
import AddButton from "../../../../buttons/button";
import LoadingSpinner from "../../../../helper-components/loading-spinner";
import SelectField from "../../../../forms/select-field";

const TaxTypeTable = ({ searchValue, reload }) => {
  const tableHeading = ["Type Name","GST TYPE", "Type Description", "Actions"];
  const [disableArrayFields, setDisableArrayFields] = useState(false);
  const [disableNewFields, setDisableNewFields] = useState(false);
  const [selectedDOtIndex, setSelectedDOtIndex] = useState(null);
  const [initialData, setItemTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleFieldChange = (index, field, value, setFieldValue) => {
    setFieldValue(`${index}.${field}`, value);
  };
  useEffect(() => {
    dispatch(taxTypeListAction({}, onFetchTaxTypeSuccess, onFetchTaxTypeError));
    setLoading(true);
  }, []);

  useEffect(() => {
    dispatch(
      taxTypeListAction(
        { searchValue },
        onFetchTaxTypeSuccess,
        onFetchTaxTypeError
      )
    );
    setLoading(true);
  }, [searchValue, reload]);

  const reloadData = () => {
    dispatch(taxTypeListAction({}, onFetchTaxTypeSuccess, onFetchTaxTypeError));
    setLoading(true);
  };

  const onFetchTaxTypeSuccess = (data) => {
    setItemTypeData(data?.data?.taxTypeList);
    setLoading(false);
  };

  const onFetchTaxTypeError = (data) => {
    errorToast(data?.message);
    setItemTypeData([]);
    setLoading(false);
  };

  const initialValues = {
    data: initialData,
    newLine: {
      name: "",
      description: "",
    },
  };

  const onSubmit = (values, { setSubmitting }) => {
    const changedObjects = [];
    let newLineObject = null;

    // Collect changed array data
    initialData.forEach((item, index) => {
      if (JSON.stringify(values.data[index]) !== JSON.stringify(item)) {
        changedObjects.push(values.data[index]);
      }
    });

    // Collect new line data if it is altered
    if (
      JSON.stringify(values.newLine) !== JSON.stringify(initialValues.newLine)
    ) {
      newLineObject = values.newLine;
    }
    if (newLineObject !== null) {
      if(newLineObject.name==null || newLineObject.name===undefined || newLineObject.name===''){
        errorToast("Tax name is required!");
        return
      }
      if(newLineObject.description==null || newLineObject.description===undefined || newLineObject.description===''){
        errorToast("Tax description is required!");
        return
      }
      dispatch(addTaxTypeAction(newLineObject, onCreateSuccess, onCreateError));
    }

    if (changedObjects.length > 0) {
      dispatch(
        updateTaxTypeAction(
          { updatingData: changedObjects },
          onUpdateSuccess,
          onUpdateError
        )
      );
    }
    setSubmitting(false);
  };

  const onCreateSuccess = (data) => {
    reloadData();
    setDisableArrayFields(false);
    setSelectedDOtIndex(null);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onCreateError = (data) => {
    setDisableArrayFields(false);
    setSelectedDOtIndex(null);
    setDisableNewFields(false);
    errorToast(data?.message);
  };

  const onUpdateSuccess = (data) => {
    setSelectedDOtIndex(null);
    reloadData();
    setDisableArrayFields(false);
    setDisableNewFields(false);
    successToast(data?.message);
  };
  const onUpdateError = (data) => {
    setSelectedDOtIndex(null);
    setDisableArrayFields(false);
    setDisableNewFields(false);
    errorToast(data?.message);
  };

  const onClickDelete = (id) => {
    dispatch(deleteTaxTypeAction({ id }, onDeletSuccess, onError));
  };
  const onDeletSuccess = (data) => {
    setSelectedDOtIndex(null);
    reloadData();
    successToast(data?.message);
  };

  const onError = (data) => {
    setSelectedDOtIndex(null);
    // data?.data?.message — HTTP error path (saga catch passes error.response)
    // data?.message       — non-200 code path (saga else passes res.data)
    const message = data?.data?.message ?? data?.message;
    errorToast(message ?? "Cannot delete. This tax type is already assigned to transactions.");
  };

  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDOtIndex(null);
    }
  };

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, dirty, handleSubmit }) => (
          <Form>
            <div
              onClick={handleClickOutside}
              className="flex flex-col justify-between"
              style={{ height: "71vh" }}
            >
              {loading ? (
                <LoadingSpinner />
              ) : (
                <div className="overflow-auto mb-auto rounded-xl table-container border border-gray-200">
                <table className=" w-full ">
                  <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                    <tr className="relative h-[50px]">
                      {tableHeading.map((heading, index) => (
                        <th
                          className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                          key={heading}
                        >
                          {heading?.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                    <tbody style={{ position: "relative" }}>
                      {values.data.map((item, index) => (
                        <tr key={index} className="h-[46px]">
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary w-20 align-middle p-0`}
                          >
                            <div className="flex items-center h-[46px] px-1">
                              <Field
                              name={`data[${index}].name`}
                              placeholder="Name"
                              disabled={disableArrayFields}
                              
                              onChange={(e) =>{
                                const value = e.target.value;
                              if (value.length > 255) {
                                  errorToast("Tax Name cannot exceed 255 characters.");
                                  return; 
                              }
                                handleFieldChange(
                                  `data[${index}]`,
                                  "name",
                                  e.target.value,
                                  setFieldValue
                                )}
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-1.5 w-full h-[38px] text-sm"
                            />
                            </div>
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary align-middle p-0 min-w-[11rem] w-[11rem]`}
                          >
                            <div className="flex items-center h-[46px] px-1 w-full overflow-visible">
                              <SelectField
                                name={`data[${index}].is_inter_state`}
                                placeholder="Select GST"
                                isDisabled={disableArrayFields}
                                parentClass="flex items-center w-full m-0 p-0 min-h-0 h-full"
                                containerClass="w-full min-w-0 h-[40px]"
                                defaultInputClass="min-h-[38px] h-[38px] rounded-[8px] bg-[var(--input-bg)] text-[var(--input-color)] text-sm font-[var(--input-font-weight)] input-field-no-spin-buttons border border-[var(--input-border)]"
                                menuPlacement="top"
                                style={{
                                  control: (base) => ({
                                    ...base,
                                    border: "1px solid var(--input-border, #d0d5dd)",
                                    minHeight: "38px",
                                    boxShadow: "none",
                                  }),
                                }}
                                options={[
                                  { label: "Inter", value: true },
                                { label: "Intra", value: false },
                                ]}
                              />
                            </div>
                          </td>
                          <td
                            className={`tab-cell text-sm fw_400 text-secondary align-middle p-0`}
                          >
                            <div className="flex items-center h-[46px] px-1">
                              <Field
                                name={`data[${index}].description`}
                              placeholder="Description"
                              disabled={disableArrayFields}
                              onChange={(e) =>{
                                const value = e.target.value;
                                if (value.length > 255) {
                                    errorToast("Description cannot exceed 255 characters.");
                                    return; 
                                }
                                handleFieldChange(
                                  `data[${index}]`,
                                  "description",
                                  e.target.value,
                                  setFieldValue
                                )}
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded px-1 py-1.5 w-full h-[38px] text-sm"
                            />
                            </div>
                          </td>

                          <td className="tab-cell w-[5rem] text-sm fw_400 text-secondary align-middle p-0">
                            <div className="flex items-center justify-center h-[46px]">
                              <button onClick={() => setSelectedDOtIndex(index)}>
                                <KibabMenu />
                              </button>
                            </div>
                            {selectedDOtIndex === index && (
                              <div
                                ref={componentRef}
                                style={{
                                  position: "absolute",
                                  right: "4rem",
                                  boxShadow:
                                    "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                }}
                                className="bg-white rounded w-38"
                              >
                                <div className="w-full p-3">
                                  <button
                                    className="w-full flex align-middle gap-2 px-2 py-1 items-center"
                                    onClick={() => onClickDelete(item?.id)}
                                  >
                                    <div className="mt-1">
                                      <DeleteIcon />
                                    </div>
                                    <span className="text-sm">Delete</span>
                                  </button>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr className="h-[46px]">
                        <td
                          className={`tab-cell text-sm fw_400 text-secondary p-0`}
                        >
                          <div className="flex items-center h-[46px] px-1">
                            <Field
                              name="newLine.name"
                              placeholder="Name"
                              disabled={disableNewFields}
                              // maxLength={255}
                              onChange={(e) =>{
                                const value = e.target.value;
                                if (value.length > 255) {
                                    errorToast("Tax Name cannot exceed 255 characters.");
                                    return; 
                                }
                                handleFieldChange(
                                  "newLine",
                                  "name",
                                  e.target.value,
                                  setFieldValue
                                )}
                              }
                              className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-1.5 w-full h-[38px] text-sm"
                              autoFocus={searchValue ? false : true}
                            />
                          </div>
                        </td>
                        <td className={`tab-cell text-sm fw_400 text-secondary p-0 min-w-[11rem] w-[11rem]`}>
                          <div className="flex items-center h-[46px] px-1 w-full overflow-visible">
                            <SelectField
                              name={`newLine.is_inter_state`}
                              placeholder="Select GST Type"
                              defaultInputClass="min-h-[38px] h-[38px] rounded-[8px] bg-[var(--input-bg)] text-[var(--input-color)] text-sm font-[var(--input-font-weight)] input-field-no-spin-buttons border border-[var(--input-border)]"
                              isDisabled={disableArrayFields}
                              parentClass="flex items-center w-full m-0 p-0 min-h-0 h-full"
                              containerClass="w-full min-w-0 h-[40px]"
                              menuPlacement="top"
                              style={{
                                control: (base) => ({
                                  ...base,
                                  border: "1px solid var(--input-border, #d0d5dd)",
                                  minHeight: "38px",
                                  boxShadow: "none",
                                }),
                              }}
                              options={[
                                { label: "Inter", value: true },
                                { label: "Intra", value: false },
                              ]}
                            />
                          </div>
                        </td>
                        <td
                          className={`tab-cell text-sm fw_400 text-secondary p-0`}
                        >
                          <div className="flex items-center h-[46px] px-1">
                            <Field
                              name="newLine.description"
                            placeholder="Description"
                            disabled={disableNewFields}
                            onChange={(e) =>{
                              const value = e.target.value;
                              if (value.length > 255) {
                                  errorToast("Description cannot exceed 255 characters.");
                                  return; 
                              }
                              handleFieldChange(
                                "newLine",
                                "description",
                                e.target.value,
                                setFieldValue
                              )}
                            }
                            className="border-0 focus:outline-none focus:ring focus:ring-blue-500 rounded py-1.5 w-full h-[38px] text-sm"
                            />
                          </div>
                        </td>

                        <td
                          className={`tab-cell text-sm fw_400 text-secondary p-0`}
                        >
                          <div className="flex items-center h-[46px]" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="flex justify-end w-full bg-white py-4 px-6 invoice-bottom-container my-3">
              <AddButton
                onclkFn={handleSubmit}
                prefixIcon={false}
                text="Save"
                type="submit"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TaxTypeTable;
